var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_27756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_424_27756)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8638 23.7459C17.8603 20.6977 22.5257 18.6881 24.8601 17.7171C31.5251 14.9449 32.91 14.4633 33.8127 14.4474C34.0113 14.4439 34.4552 14.4931 34.7427 14.7265C34.9855 14.9235 35.0523 15.1896 35.0843 15.3764C35.1163 15.5632 35.1561 15.9887 35.1244 16.3212C34.7633 20.1162 33.2004 29.3256 32.4053 33.576C32.0689 35.3745 31.4065 35.9775 30.7652 36.0365C29.3714 36.1648 28.3131 35.1155 26.9632 34.2306C24.8509 32.846 23.6576 31.984 21.6072 30.6328C19.2377 29.0713 20.7738 28.2131 22.1242 26.8105C22.4776 26.4435 28.6183 20.858 28.7372 20.3513C28.7521 20.2879 28.7659 20.0517 28.6255 19.927C28.4852 19.8022 28.2781 19.8449 28.1286 19.8788C27.9168 19.9269 24.5423 22.1573 18.0053 26.5699C17.0475 27.2277 16.1799 27.5481 15.4026 27.5313C14.5457 27.5128 12.8973 27.0468 11.6719 26.6485C10.1689 26.1599 8.97432 25.9016 9.07834 25.0719C9.13252 24.6397 9.72767 24.1977 10.8638 23.7459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_424_27756",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 47.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_27756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5603a18cd64b7d8820ff3cc3babe312e.svg";
export { ForwardRef as ReactComponent };